import { userFields } from '@openx/components-administration/lib/constants.ts';
import { OxsUserRole } from '@openx/types/user.ts';
import type { TFunction } from 'i18next';
import { number, object, string } from 'yup';
import { isAdminRoleAllowed } from './utils.ts';

export const getValidationSchema = (t: TFunction) =>
  object().shape({
    [userFields.ACCOUNT]: object({
      id: string(),
      name: string(),
      depth: number(),
    }).required(t('Organization is required')),
    [userFields.EMAIL]: string().email(t('Please enter a valid email address')).required(t('Email is required')),
    [userFields.FIRST_NAME]: string().required(t('First Name is required')),
    [userFields.LAST_NAME]: string().required(t('Last Name is required')),
    [userFields.ROLE]: string()
      .oneOf(Object.values(OxsUserRole))
      .required(t('Role is required'))
      .test(
        'adminRoleAllowed',
        t('Admin role is available only for the OpenAudience organization'),
        (role, context) => role !== OxsUserRole.ADMIN || isAdminRoleAllowed(context.parent[userFields.ACCOUNT])
      ),
  });
